export default __webpack_public_path__ + "static/media/dummy-img.25d48241.png";